const steps = [
  {
    number: '01',
    icon: 'ri-discuss-line',
    title: 'Beratung & Farbanalyse',
    description: 'Wir besprechen deine Wünsche, analysieren die aktuelle Zahnfarbe und finden die optimale Anwendung für dich.',
  },
  {
    number: '02',
    icon: 'ri-flashlight-line',
    title: 'Sanfte Aufhellung mit LED & PAP',
    description: 'Das peroxidfreie PAP-Gel wird aufgetragen und mit moderner LED-Technologie aktiviert. Unsere schmerzfreie kosmetische Zahnaufhellung in Köln hinterlässt keine Empfindlichkeiten.',
  },
  {
    number: '03',
    icon: 'ri-sparkling-2-line',
    title: 'Dein strahlendes Lächeln',
    description: 'Sichtbares Ergebnis direkt nach der kosmetischen Zahnaufhellung. Wir geben dir persönliche Pflegetipps mit auf den Weg.',
  },
];

export default function HowItWorks() {
  return (
    <section className="bg-blush py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14 md:mb-16">
          <span className="font-sans text-xs tracking-widest uppercase text-rose font-semibold">
            So einfach geht's
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-medium text-charcoal mt-3 mb-4">
            So funktioniert's
          </h2>
          <p className="font-sans text-base text-charcoal/60 max-w-md mx-auto leading-relaxed">
            Von der Beratung bis zum strahlenden Ergebnis — kosmetische Zahnaufhellung in nur einem Termin.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6 relative">
          {/* Connecting line */}
          <div className="hidden md:block absolute top-12 left-[calc(16.5%+24px)] right-[calc(16.5%+24px)] h-px border-t-2 border-dashed border-rose/40" />

          {steps.map((step, i) => (
            <div key={i} className="relative flex flex-col items-center text-center">
              {/* Number circle */}
              <div className="relative z-10 w-20 h-20 flex items-center justify-center bg-rose rounded-full mb-6 flex-shrink-0">
                <span className="font-serif text-white text-2xl font-medium">{step.number}</span>
              </div>

              {/* Content box */}
              <div className="bg-white/60 rounded-2xl px-6 py-6 w-full">
                <div className="w-10 h-10 flex items-center justify-center bg-rose/15 rounded-xl mx-auto mb-4">
                  <i className={`${step.icon} text-rose text-xl`} />
                </div>
                <h3 className="font-sans text-base font-semibold text-charcoal mb-3">
                  {step.title}
                </h3>
                <p className="font-sans text-sm text-charcoal/65 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a
            href="https://simplybook.me"
            target="_blank"
            rel="nofollow noreferrer"
            className="inline-flex items-center gap-2 bg-rose hover:bg-rose-dark text-white font-sans font-medium text-base px-8 py-4 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Jetzt Termin buchen
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-calendar-line text-base" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
